<div
  class="avatar-container"
  [class.avatar-x-small]="size === 'x-small'"
  [class.avatar-small]="size === 'small'"
  [class.avatar-large]="size === 'large'">
  @if (!avatarLoaded) {
    <div
      class="placeholder"
      [ngStyle]="{
        'background-color':
          placeholderBackgroundColor || userInitials?.backgroundColor,
        color: placeholderColor || userInitials?.color,
      }">
      {{ userInitials?.text }}
    </div>
  }
  <div [style.display]="avatarLoaded ? 'flex' : 'none'">
    <img
      class="img"
      [src]="avatar"
      (load)="avatarLoaded = true"
      (error)="avatarLoaded = false"
      alt="avatar" />
  </div>
</div>
